<template>
  <div
    class="config-form-content adminWeeducAdvanced adminWeeducConfig weeduc-admin-config weeduc-admin-advanced"
  >
    <div class="weeduc-admin-advanced__intro">
      <h3 class="weeduc-admin-advanced__title">Avançado</h3>
      <p class="weeduc-admin-advanced__lead">
        Temas da loja virtual e do portal do aluno, CSS e JavaScript personalizados e avisos de conteúdo.
      </p>
    </div>

    <div class="row g-3 g-lg-4 weeduc-admin-config-layout mx-0" v-if="hasReady">
      <div class="col-12 col-lg-6 weeduc-admin-config-col">
        <div class="weeduc-admin-config-section">
          <h3 class="weeduc-admin-config-section-title">Loja virtual</h3>
          <p class="weeduc-admin-config-section-lead">
            Aparência da vitrine e folha de estilos opcional.
          </p>

          <div class="form-group weeduc-admin-advanced-field">
            <v-select
              v-model="typeLayoutPortalEcommerce"
              :items="themeOptions"
              item-title="text"
              item-value="value"
              label="Tema Loja Virtual"
              variant="outlined"
              class="filter-form-control inputd weeduc-admin-v-field"
              :menu-props="adminSelectMenuProps"
              density="compact"
              hide-details
            />
            <small class="form-small-description">Tema padrão para a loja virtual.</small>
            <div class="theme-description mt-2 weeduc-admin-advanced-theme-hint">
              <p class="mb-1">
                <strong>Clean:</strong>
                Design minimalista e cores claras, experiência leve e moderna.
              </p>
              <p class="mb-0">
                <strong>Dark:</strong>
                Fundo escuro e contraste alto; confortável em ambientes com pouca luz.
              </p>
            </div>
          </div>

          <div class="form-group">
            <label class="form-label" for="weeducAdvancedCss">CSS</label>
            <textarea
              id="weeducAdvancedCss"
              class="form-input weeduc-admin-advanced-textarea"
              v-model="css"
              rows="8"
              placeholder="<style>...</style>"
            />
            <small class="form-small-description">CSS personalizado para a loja virtual.</small>
            <small class="form-small-description weeduc-admin-advanced-alert">
              Atenção: CSS personalizado pode afetar o funcionamento do site. Use com cuidado.
            </small>
          </div>

          <div class="form-group">
            <v-select
              v-model="contentWarning"
              :items="contentWarningOptions"
              item-title="text"
              item-value="value"
              label="Aviso de Conteúdo Sensível"
              variant="outlined"
              class="filter-form-control inputd weeduc-admin-v-field"
              :menu-props="adminSelectMenuProps"
              density="compact"
              hide-details
            />
            <small class="form-small-description">Exibir aviso de conteúdo sensível no site.</small>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-6 weeduc-admin-config-col">
        <div class="weeduc-admin-config-section">
          <h3 class="weeduc-admin-config-section-title">Portal do aluno</h3>
          <p class="weeduc-admin-config-section-lead">
            Tema do portal e scripts opcionais.
          </p>

          <div class="form-group weeduc-admin-advanced-field">
            <v-select
              v-model="typeLayoutPortalStudent"
              :items="themeOptions"
              item-title="text"
              item-value="value"
              label="Tema Portal do Aluno"
              variant="outlined"
              class="filter-form-control inputd weeduc-admin-v-field"
              :menu-props="adminSelectMenuProps"
              density="compact"
              hide-details
            />
            <small class="form-small-description">Tema padrão para o portal do aluno.</small>
            <div class="theme-description mt-2 weeduc-admin-advanced-theme-hint">
              <p class="mb-1">
                <strong>Clean:</strong>
                Design minimalista e cores claras, experiência leve e moderna.
              </p>
              <p class="mb-0">
                <strong>Dark:</strong>
                Fundo escuro e contraste alto; confortável em ambientes com pouca luz.
              </p>
            </div>
          </div>

          <div class="form-group">
            <label class="form-label" for="weeducAdvancedJs">JS</label>
            <textarea
              id="weeducAdvancedJs"
              class="form-input weeduc-admin-advanced-textarea"
              v-model="js"
              rows="8"
              placeholder="<script>...</script>"
            />
            <small class="form-small-description">JavaScript personalizado para o portal do aluno.</small>
            <small class="form-small-description weeduc-admin-advanced-alert">
              Atenção: JS personalizado pode afetar o funcionamento do site. Use com cuidado.
            </small>
          </div>
        </div>
      </div>
    </div>

    <Loader :isActive="hasReady" />

    <div class="buttons-container weeduc-admin-site-form-actions">
      <div class="button d-flex flex-wrap gap-2 justify-content-end">
        <button type="button" class="btn btn-block btn-content" @click="save()" :disabled="loading">
          <span v-if="!loading">Salvar e Publicar</span>
          <span v-else class="d-inline-flex align-items-center gap-2">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
            Salvando…
          </span>
        </button>
        <button type="button" class="btn btn-block btn-content" @click="clearCache()" :disabled="loading">
          <span v-if="!loading">Limpar Cache</span>
          <span v-else class="d-inline-flex align-items-center gap-2">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
            Aguarde…
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import apiSiteAdvanced from '@/utils/Site/advanced'
import Loader from '@/components/Loader/loader.vue'
import websiteApi from '@/utils/Weflix/website'
import companyApi from '@/utils/company'
import { toast } from 'vue3-toastify'

export default {
  name: 'AdminWeeducAdvanced',
  components: {
    Loader,
  },
  data() {
    return {
      typeLayoutPortalEcommerce: '',
      typeLayoutPortalStudent: '',
      contentWarning: '',
      infoCompany: {},
      css: '',
      js: '',
      loading: false,
      hasReady: true,
      themeOptions: [
        { text: 'Selecione uma opção', value: '' },
        { text: 'Dark', value: '0' },
        { text: 'Clean', value: '1' },
      ],
      contentWarningOptions: [
        { text: 'Selecione uma opção', value: '' },
        { text: 'Sim', value: '1' },
        { text: 'Não', value: '0' },
      ],
    }
  },
  computed: {
    ...mapState(['token', 'dark']),

    adminSelectMenuProps() {
      return this.dark ? { contentClass: 'weeduc-admin-select-menu-dark' } : {}
    },
  },
  methods: {
    async getAdvancedData() {
      try {
        const response = await apiSiteAdvanced.getAdvancedData(this.token)
        this.typeLayoutPortalEcommerce =
          response.typeLayout !== undefined && response.typeLayout !== null
            ? String(response.typeLayout)
            : ''
        this.typeLayoutPortalStudent =
          response.typeLayoutPortal !== undefined && response.typeLayoutPortal !== null
            ? String(response.typeLayoutPortal)
            : ''
        this.contentWarning =
          response.contentWarning !== undefined && response.contentWarning !== null
            ? String(response.contentWarning)
            : ''
        this.css = response.css || ''
        this.js = response.javascript || ''
        this.hasReady = true
      } catch (error) {
        toast.error('Erro ao obter dados')
        console.error('Erro ao obter dados avançados:', error)
      }
    },
    async getInfoCompany() {
      try {
        const response = await companyApi.getInfoCompany(this.token)
        this.infoCompany = response
        this.contentWarning =
          response.ageRestricted !== undefined && response.ageRestricted !== null
            ? String(response.ageRestricted)
            : ''
      } catch (error) {
        toast.error('Erro ao obter dados da empresa')
      }
    },
    async setInfoCompany() {
      try {
        const payload = {
          ...this.infoCompany,
          ageRestricted: this.contentWarning !== '' ? parseInt(this.contentWarning, 10) : null,
        }
        await companyApi.setInfoCompany(this.token, payload)
        toast.success('Dados da empresa salvos com sucesso!')
      } catch (error) {
        toast.error('Erro ao salvar dados da empresa')
        console.error('Erro ao salvar dados da empresa:', error)
      }
    },
    async save() {
      this.loading = true
      this.hasReady = false
      const payload = {
        typeLayout:
          this.typeLayoutPortalEcommerce !== '' ? parseInt(this.typeLayoutPortalEcommerce, 10) : null,
        typeLayoutPortal:
          this.typeLayoutPortalStudent !== '' ? parseInt(this.typeLayoutPortalStudent, 10) : null,
        contentWarning: this.contentWarning !== '' ? parseInt(this.contentWarning, 10) : null,
        css: this.css,
        javascript: this.js,
      }
      try {
        await apiSiteAdvanced.putAdvancedData(this.token, payload)
        if (this.contentWarning !== '') {
          await this.setInfoCompany()
        }
        await this.clearCache({ silent: true })
        await this.getAdvancedData()
        await this.getInfoCompany()
        toast.success('Dados avançados salvos com sucesso!')
      } catch (error) {
        toast.error('Erro ao salvar dados avançados')
        console.error('Erro ao salvar dados avançados:', error)
      } finally {
        this.hasReady = true
        this.loading = false
      }
    },
    async clearCache(options = {}) {
      const silent = options.silent === true
      try {
        await websiteApi.clearCache(this.token)
        if (!silent) {
          toast.success('Cache limpo com sucesso!')
        }
      } catch (error) {
        toast.error('Erro ao limpar cache')
        console.error('Erro ao limpar cache', error)
      }
    },
  },
  created() {
    this.getAdvancedData()
    this.getInfoCompany()
  },
}
</script>

<style scoped>
@import url('@/css/weeduc/admin/dashboard-weflix-shell.css');
@import '@/css/weeduc/admin/config.css';
@import '@/css/weeduc/admin/advanced.css';
</style>
